const easeInOutCubic = (t: number): number =>
  t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;

/**
 * Smoothly animates the container's horizontal scroll position
 * from its current scrollLeft to a specified targetX value.
 */
export const animateHorizontalScroll = (
  container: HTMLElement,
  targetX: number,
  duration = 300,
): void => {
  const startX = container.scrollLeft;
  const diff = targetX - startX;
  const startTime = performance.now();

  function step(currentTime: number) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeInOutCubic(progress);

    container.scrollLeft = startX + diff * easedProgress;

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
};

/**
 * Centers the item in the horizontal container if possible.
 */
export const centerItemInContainer = (
  container: HTMLElement,
  item: HTMLElement,
  duration = 300,
): void => {
  const containerWidth = container.clientWidth;
  const containerScrollWidth = container.scrollWidth;

  const itemWidth = item.offsetWidth;
  const itemLeft = item.offsetLeft;
  const itemCenter = itemLeft + itemWidth / 2;

  const containerCenter = containerWidth / 2;

  // Calculate the raw targetX so that item is in the container center
  let targetX = itemCenter - containerCenter;

  // Clamp so we don’t scroll beyond the content
  if (targetX < 0) {
    targetX = 0;
  }
  // The max scroll we can do is (totalWidth - containerWidth)
  const maxScroll = containerScrollWidth - containerWidth;
  if (targetX > maxScroll) {
    targetX = maxScroll;
  }

  animateHorizontalScroll(container, targetX, duration);
};
